export const SuggestedQuestionsRoutes = [
  {
    path: ':channel/suggested-questions',
    lazy: () => import('./SuggestedQuestions.page'),
  },
] as const
